<template>
  <div>
    <v-alert
      v-if="showItcNote"
      type="info"
      outlined
      dense
      border="left"
      dismissible
      class="mb-4"
      @input="dismissItcNote"
    >
      Expenses recorded here before Vendors &amp; Purchases existed aren't
      included in ITC tracking. If a past purchase still matters for Input
      Tax Credit, re-enter it as a Bill under Purchases.
    </v-alert>

    <app-ag-grid
      title="Transactions"
      :columnDefs="columnDefs"
      :rowData="transactions"
      :loading="loading"
      :mobileCard="mobileCard"
      @refresh="fetchTransactions"
      @add="onAdd"
      @row-dbl-click="
        (data) => $router.push({ path: `transactions/${data._id}/edit` })
      "
    ></app-ag-grid>
  </div>
</template>

<script>
import AppAgGrid from "@/components/common/ag-grid.vue";

export default {
  name: "TransactionsPage",
  components: { AppAgGrid },

  data() {
    return {
      loading: false,
      showItcNote: !localStorage.getItem("txn-itc-note-dismissed"),

      columnDefs: [
        {
          headerName: "View",
          field: "_id",
          width: 80,
          cellRenderer: (params) => {
            return `
              <i
                class="mdi mdi-eye view-transactions"
                data-id="${params.data._id}"
                title="View Transaction"
                style="
                  cursor: pointer;
                  font-size: 18px;
                  color: #0a5a90;
                "
              ></i>
            `;
          },

          onCellClicked: (params) => {
            if (params.event.target.classList.contains("view-transactions")) {
              this.$router.push({
                path: `transactions/${params.data._id}/view`,
              });
            }
          },
        },
        { headerName: "Customer / Vendor", field: "customerName" },
        { headerName: "Type", field: "type" },
        {
          headerName: "Amount",
          field: "amount",
          valueFormatter: (p) => {
            if (p.value == null) return "-";

            return new Intl.NumberFormat("en-IN", {
              style: "currency",
              currency: "INR",
            }).format(p.value);
          },
        },
        { headerName: "Category", field: "category" },
        { headerName: "Payment Method", field: "paymentMethod" },
        { headerName: "Note", field: "note" },
        {
          headerName: "Created At",
          field: "createdAt",
          valueFormatter: (p) => {
            if (!p.value) return "-";

            const date = new Date(p.value);
            const day = String(date.getDate()).padStart(2, "0");
            const month = String(date.getMonth() + 1).padStart(2, "0");
            const year = date.getFullYear();

            return `${day}-${month}-${year}`;
          },
        },
        { headerName: "User", field: "userId.name" },
        { headerName: "Email", field: "userId.email", width: 300 },
      ],
    };
  },

  computed: {
    transactions() {
      return this.$store.state.transactions.transactions;
    },

    mobileCard() {
      return {
        title: (row) => row.customerName || row.category || "-",
        subtitle: (row) => row.category || "-",
        badge: (row) => ({
          text: row.type || "-",
          style:
            row.type === "INCOME"
              ? { background: "#e6f7ec", color: "#15803d" }
              : { background: "#fdecea", color: "#c62828" },
        }),
        fields: (row) => [
          {
            label: "Amount",
            value: row.amount == null
              ? "-"
              : new Intl.NumberFormat("en-IN", {
                  style: "currency",
                  currency: "INR",
                }).format(row.amount),
          },
          { label: "Method", value: row.paymentMethod || "-" },
        ],
        actions: (row) => [
          {
            label: "View",
            icon: "mdi-eye-outline",
            color: "#0a5a90",
            onClick: () => this.$router.push({ path: `transactions/${row._id}/view` }),
          },
          {
            label: "Edit",
            icon: "mdi-pencil-outline",
            color: "#475569",
            onClick: () => this.$router.push({ path: `transactions/${row._id}/edit` }),
          },
        ],
      };
    },
  },

  created() {
    this.fetchTransactions();
  },

  methods: {
    async fetchTransactions() {
      this.loading = true;
      try {
        await this.$store.dispatch("transactions/getTransactions");
      } finally {
        this.loading = false;
      }
    },

    onAdd() {
      this.$router.push({ path: "transactions/create" });
    },

    dismissItcNote() {
      localStorage.setItem("txn-itc-note-dismissed", "1");
    },
  },
};
</script>
